import React, { useState, useEffect } from "react";
import Fire from "../Api/Fire";
import ErrorDialog from "../components/errorDialog";
import SuccessDialog from "../components/successDialog";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useTranslation } from "react-i18next";

const AddBlog = () => {
  const [error, setError] = useState("خطأ");
  const [showForm, setShowForm] = useState(false);
  const [showFormSuccess, setShowFormSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [title, setTitle] = useState("");
  const [cover, setCover] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "عز للتحول الرقمي - نشر مدونة";
    window.scrollTo(0, 0);
  }, []);

  //Publish Announcement to team.
  const addBlog = async (event) => {
    setLoading((loading) => true);
    event.preventDefault();
    if (value.replace(/<(.|\n)*?>/g, "").trim().length === 0 || title.replace(/<(.|\n)*?>/g, "").trim().length === 0) {
      setError((error) => t("fill"));
      setShowForm((showForm) => true);
      setLoading((loading) => false);
    } else {
      const response = await Fire.addBlog({ userId: Fire.uid, post: value, title: title, createdAt: new Date(), cover: cover });
      if (response) {
        setValue((value) => "");
        setShowFormSuccess((showFormSuccess) => true);
      } else {
        setError((error) => response);
        setShowForm((showForm) => true);
      }
      setLoading((loading) => false);
    }
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote", "code-block"],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction

      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ["link"],

      ["clean"],
    ],
  };

  const format = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "color",
    "align",
    "script",
    "background",
  ];

  return (
    <div className="container bg-white rounded" data-aos="zoom-in">
      <div className="row">
        <div className="col-lg-12 py-4 text-center">
          <h4>
            <b>{t("add-blog")}</b>
          </h4>
          <div className={`form-group ${t("language") === "en" ? "text-right" : "text-left"}`}>
            <label htmlFor="title">
              <b>{t("title")}</b>
            </label>
            <input
              type="text"
              value={title}
              className="col-lg-12 bg-light text-right"
              onChange={(event) => setTitle(event.target.value)}
              required
            />
          </div>
          <div className={`form-group ${t("language") === "en" ? "text-right" : "text-left"}`}>
            <label htmlFor="profileImage">
              <b>{t("cover")}</b>
            </label>
            <input
              type="file"
              className="col-lg-12 bg-light text-right"
              name="profileImage"
              id="profileImage"
              onChange={(event) => setCover(event.target.files[0])}
            />
          </div>
          <ReactQuill className="py-3" theme="snow" value={value} onChange={setValue} modules={modules} formats={format} />
          {loading ? (
            <div className="text-center mt-3">
              <div className="spinner-border text-dark" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="form-group m-0">
              <button type="button" className="btn btn-warning btn-block text-light mt-3" onClick={(event) => addBlog(event)}>
                {t("post")}
              </button>
            </div>
          )}
        </div>
        {showForm ? (
          <div className="contact-form bg-white rounded shadow">
            <ErrorDialog error={error} onClick={() => setShowForm((showForm) => false)} />
          </div>
        ) : null}
        {showFormSuccess ? (
          <div className="contact-form bg-white rounded shadow">
            <SuccessDialog success={t("post-success")} onClick={() => setShowFormSuccess((showForm) => false)} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AddBlog;
